module.exports = __webpack_public_path__ + "static/media/spis-dzialow-i-tematow-informatyka-2.df03b673.pdf";